module.exports = __webpack_public_path__ + "static/media/glowna_foto.2a75a913.png";